import { translationDataState, useRecoilValue } from '../../../store';
import styled from 'styled-components';

const BlCardBarcode = styled.div`
  //margin-top: 18px;

  @media screen and (max-width: 760px) {
    margin-top: 9px;
    max-width: 100%;
    overflow: hidden;
  }
`;
const BlCardBtnWrap = styled.div`
  position: relative;
  margin-top: 5px;
  text-align: center;

  .bl-card-btn {
    background: #ffffff;
    border: 1px solid #000000;
    box-sizing: border-box;
    box-shadow: -4px 4px 0px rgba(255, 255, 255, 0.25);
    border-radius: 12px;
    padding: 8px 22px;

    &:active {
      opacity: 0.9;
    }
  }

  .bl-btn-hr {
    width: 65px;
    top: 0px;
    border-color: black;
    position: absolute;

    &.bl-hr-left {
      left: 20px;
    }

    &.bl-hr-right {
      right: 20px;
    }

    @media screen and (max-width: 760px) {
      width: 20px;
    }
  }
`;

const MoreInfoBtn = ({ ticketInfoUlr }: { ticketInfoUlr: string }) => {
  const { more_info = 'More Info' } = useRecoilValue(translationDataState);

  return ticketInfoUlr ? (
    <BlCardBtnWrap className="bl-card-btn-wrap">
      <a
        href={ticketInfoUlr.includes('http') ? ticketInfoUlr : `http://${ticketInfoUlr}`}
        target="_blank"
      >
        <button className="bl-card-btn">{more_info}</button>
        <hr className="bl-btn-hr bl-hr-left" />
        <hr className="bl-btn-hr bl-hr-right" />
      </a>
    </BlCardBtnWrap>
  ) : (
    <BlCardBarcode className="bl-card-barcode">
      <img src="/ticketing/barcode.png" alt="ticket_barcode" />
    </BlCardBarcode>
  );
};

export default MoreInfoBtn;
